const PUBLIC_URL = process.env.PUBLIC_URL || '';

/**
 * Resolves a path under public/ (e.g. "images/logo.png") to an absolute URL so
 * images keep working on every route, including ones with a trailing slash.
 * @param {string} path
 * @returns {string}
 */
export const assetUrl = (path) => `${PUBLIC_URL}/${path.replace(/^\/+/, '')}`;
